export default __webpack_public_path__ + "static/media/Delhi_3.62a52905.png";